import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalsComponent } from '../modals.component';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'modal-datetime-picker',
  templateUrl: './datetime-picker.component.html',  
  styleUrls:['./datetime-picker.component.scss'],
})
export class DatetimePickerModalComponent extends ModalsComponent {
  @Input() title = 'pick datetime';

  datetimeCtrl:FormControl;
  @Input() default_value:number;
  @Input() min_value:number;
  @Input() max_value:number;

  minDate:Date;
  maxDate:Date;
  constructor(
    modalRef : BsModalRef,
  ) {
    super(modalRef)
  }

  ngOnInit () {
    this.datetimeCtrl = new FormControl(this.default_value && new Date(this.default_value) || null);
    this.minDate = this.min_value && new Date(this.min_value) || null; 
    this.maxDate = this.max_value && new Date(this.max_value) || null; 
  }

  //
  cancel () {
    this.modalRef.hide();
  }
}